import { render } from "./RectangleEditor.vue?vue&type=template&id=eb5c8d48&scoped=true&ts=true"
import script from "./RectangleEditor.vue?vue&type=script&lang=ts"
export * from "./RectangleEditor.vue?vue&type=script&lang=ts"

import "./RectangleEditor.vue?vue&type=style&index=0&id=eb5c8d48&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eb5c8d48"]])

export default __exports__